import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { UNHANDLE_ERROR_MESSAGE } from '@core/utils/constants';
import { HotToastService } from '@ngxpert/hot-toast';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorService implements ErrorHandler {
  constructor(
    private injector: Injector,
    private translateService: TranslateService
  ) {}

  get toastService() {
    return this.injector.get(HotToastService);
  }

  handleError(error: Error | HttpErrorResponse) {
    this.toastService.error().close();

    if (error instanceof HttpErrorResponse) {
      this.handleHttpError(error);
    }

    if (!navigator.onLine) {
      this.toastService.error('Revisa tu conexión a internet');
    }

    console.error(error);
  }

  private handleHttpError({ error: httpError, status }: HttpErrorResponse) {
    const messageCode = httpError?.error?.codigo;
    this.toastService.error().close();
    const timeoutHttpCodes = [
      HttpStatusCode.GatewayTimeout,
      HttpStatusCode.RequestTimeout,
    ];

    if (timeoutHttpCodes.includes(status)) {
      this.toastService.error(
        'La respuesta ha tardado en responder, inténtalo de nuevo.'
      );
    } else if (messageCode) {
      this.toastService.error(
        this.translateService.instant(`errors.${messageCode}`)
      );
    } else {
      this.toastService.error(UNHANDLE_ERROR_MESSAGE);
    }
  }
}
